import { isAxiosError } from 'axios'

import {
  OFFER_VALIDATION_ERROR_TYPES,
  type OfferValidationErrorType,
  type ValidationErrorResponse,
} from '@/types'

const UNPROCESSABLE_ENTITY_STATUS = 422

const isOfferValidationErrorType = (
  value: unknown
): value is OfferValidationErrorType =>
  OFFER_VALIDATION_ERROR_TYPES.some((type) => type === value)

export const getOfferValidationError = (
  error: unknown
): ValidationErrorResponse | undefined => {
  if (!isAxiosError<Partial<ValidationErrorResponse>>(error)) return undefined
  const response = error.response
  if (response?.status !== UNPROCESSABLE_ENTITY_STATUS) return undefined

  const { type, details, message, traceId } = response.data
  if (!isOfferValidationErrorType(type)) return undefined
  if (!Array.isArray(details) || details.length === 0) return undefined

  return {
    status: response.status,
    type,
    message: message ?? '',
    details,
    traceId,
  }
}
